import { render, staticRenderFns } from "./omsskulog.vue?vue&type=template&id=60ff83a5"
import script from "./omsskulog.vue?vue&type=script&lang=js"
export * from "./omsskulog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports